import { createApi } from '@reduxjs/toolkit/query/react';
import { createApiConfig } from '../../createApiConfig';

export const uMUserPermissionsApi = createApi({
  reducerPath: 'uMUserPermissionsApi',
  ...createApiConfig(process.env.REACT_APP_API_BASE_URL),
  endpoints: (builder) => ({
    listUserPermissions: builder.query({
      query: (params) => ({
        url: `users/auth-user-permissions/`,
        params,
      }),
    }),
    assignPermissionToUser: builder.mutation({
      query: (data) => ({
        url: `users/auth-user-permissions/`,
        method: 'POST',
        body: data,
      }),
    }),
    deletePermissionFromUser: builder.mutation({
      query: (id) => ({
        url: `users/auth-user-permissions/${id}/`,
        method: 'DELETE',
      }),
    }),
    bulkDeletePermissionFromUser: builder.mutation({
      query: (data) => ({
        url: `users/auth-user-permissions/`,
        method: 'DELETE',
        body: data,
      }),
    }),
  }),
});

export const {
  useListUserPermissionsQuery,
  useAssignPermissionToUserMutation,
  useDeletePermissionFromUserMutation,
  useBulkDeletePermissionFromUserMutation,
} = uMUserPermissionsApi;
